import type { CSSProperties, HTMLAttributes } from "react";
import "../../styles/kineticTextLoader.css";

interface KineticTextLoaderProps extends HTMLAttributes<HTMLSpanElement> {
  text?: string;
}

export function KineticTextLoader({ className = "", text = "Loading", ...props }: KineticTextLoaderProps) {
  return (
    <span aria-label={text} className={`kinetic-text-loader ${className}`.trim()} role="status" {...props}>
      <span aria-hidden="true" className="kinetic-text-loader__letters">
        {text.split("").map((letter, index) => (
          <span className="kinetic-text-loader__letter" key={`${letter}-${index}`} style={{ "--letter-index": index } as CSSProperties}>
            {letter === " " ? "\u00a0" : letter}
          </span>
        ))}
      </span>
    </span>
  );
}
